export default __webpack_public_path__ + "static/media/pitch-loader.dd4f77e4.png";